module.exports = __webpack_public_path__ + "media/video.cce38ec7.mp4";